<app-pull-to-refresh></app-pull-to-refresh>
<app-kiga-search [regionName]="regionName" (search)="filter($event)"></app-kiga-search>
<div class="content-container">
    <div *ngFor="let kiga of filteredKigas">
        <app-kiga-card [kiga]="kiga" [routerLink]="['/kiga/' + kiga.slug]"></app-kiga-card>
    </div>
</div>
